import React from 'react';
import { Chip } from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  SupervisedUserCircle as PowerUserIcon,
  ManageAccounts as SuperUserIcon,
  Person as UserIcon,
} from '@mui/icons-material';

/**
 * Role Badge Component
 * Displays user role with appropriate color and icon
 */
const RoleBadge = ({ role, size = 'small', showIcon = true }) => {
  const getRoleConfig = (role) => {
    switch (role) {
      case 'Admin':
        return {
          color: 'secondary', // Purple
          icon: <AdminIcon fontSize={size} />,
          label: 'Admin',
        };
      case 'PowerUser':
        return {
          color: 'primary', // Blue
          icon: <PowerUserIcon fontSize={size} />,
          label: 'Power User',
        };
      case 'SuperUser':
        return {
          color: 'success', // Green
          icon: <SuperUserIcon fontSize={size} />,
          label: 'Super User',
        };
      case 'User':
        return {
          color: 'default', // Gray
          icon: <UserIcon fontSize={size} />,
          label: 'User',
        };
      default:
        return {
          color: 'default',
          icon: <UserIcon fontSize={size} />,
          label: role,
        };
    }
  };

  const config = getRoleConfig(role);

  return (
    <Chip
      label={config.label}
      icon={showIcon ? config.icon : undefined}
      color={config.color}
      size={size}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default RoleBadge;
